import { RootState } from '../../store';

export const selectSubOrgList = (state: RootState) => state.subOrgs.list.data;
export const selectSubOrgListLoading = (state: RootState) => state.subOrgs.list.loading;
export const selectSubOrgListError = (state: RootState) => state.subOrgs.list.error;

export const selectSubOrg = (state: RootState) => state.subOrgs.single.data;
export const selectSubOrgLoading = (state: RootState) => state.subOrgs.single.loading;
export const selectSubOrgError = (state: RootState) => state.subOrgs.single.error;

export const selectCreateSubOrg = (state: RootState) => state.subOrgs.create.data;
export const selectCreateSubOrgLoading = (state: RootState) => state.subOrgs.create.loading;
export const selectCreateSubOrgError = (state: RootState) => state.subOrgs.create.error;

export const selectUpdateSubOrg = (state: RootState) => state.subOrgs.update.data;
export const selectUpdateSubOrgLoading = (state: RootState) => state.subOrgs.update.loading;
export const selectUpdateSubOrgError = (state: RootState) => state.subOrgs.update.error;

export const selectDeleteSubOrg = (state: RootState) => state.subOrgs.delete.data;
export const selectDeleteSubOrgLoading = (state: RootState) => state.subOrgs.delete.loading;
export const selectDeleteSubOrgError = (state: RootState) => state.subOrgs.delete.error;
